<div class="feature-section bg-lem-green-light p-3 rounded-3">
    <h2 class="fs-4 mb-4 fw-semibold text-center">Interaktive Aufgaben</h2>
    <div #features id="section-interactivity" class="feature-list align-items-start d-flex gap-4 justify-content-center">
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'icon-video.png' | asset" alt="Feature Video" />
            <span><strong>Erklärvideos</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'hsm-icon.png' | asset" alt="Feature Aufgabenverwaltung" />
            <span><strong>Aufgaben-Verwaltung</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'welcome/icon-assignment-menu.png' | asset" alt="Feature Aufgaben-Links mit Menü" />
            <span><strong>Aufgaben-Links mit Menü</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'welcome/icon-handwriting.png' | asset" alt="Feature Handschrifterkennung" />
            <span><strong>Handschriftliche Formel-Erkennung</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'welcome/icon-digigeo.png' | asset" alt="Feature Geometrie" />
            <span><strong>digi.GEO</strong><br />Geometrie Funktionen</span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'welcome/icon-translation.png' | asset" alt="Feature Übersetzung" />
            <span><strong>Übersetzen Funktion</strong></span>
        </div>
    </div>
</div>